import React from 'react'
import { useLocation, withRouter } from 'react-router'

import { DiningOptionBehavior } from 'src/apollo/onlineOrdering'
import { RequestContextProps } from 'src/lib/js/context'

import { SiteTheme } from 'shared/js/types'
import { getTargetOrigin } from 'shared/js/utils/iframeUtils'

import Meta from 'public/components/default_template/meta/Meta'
import Map from 'public/components/google_maps/Map'
import { decodeGuids, legacyDecodeGuidsB64 } from 'shared/utils/urlUtils'

type Props = RequestContextProps & {
  color?: string | null
  siteTheme?: SiteTheme
}

export const MapPage = ({
  staticContext,
  color,
  siteTheme
}: Partial<Props>) => {
  const referrer =
    typeof window !== 'undefined'
      ? window.__REFERRER__
      : staticContext?.req?.headers.referer

  const { search } = useLocation()
  const params = new URLSearchParams(search)

  const selectedGuid = params.get('selectedGuid')
  const selectedDiningOptionParam = params.get('selectedDiningOption')
  const style = params.get('style')
  const guidsParam = params.get('guidsBin')
  const guidsB64Param = params.get('guidsB64')
  const locationGuids = guidsParam
    ? decodeGuids(guidsParam)
    : guidsB64Param
    ? legacyDecodeGuidsB64(guidsB64Param)
    : []
  const orderPathPattern = params.get('orderPathPattern')
  const hostName = params.get('hostName')
  const sourceId = params.get('sourceId')
  const originParam = params.get('origin')
  const targetOrigin = getTargetOrigin(originParam, referrer)

  if (!locationGuids?.length || !targetOrigin) {
    if (staticContext) {
      staticContext.statusCode = 400
    }

    return null
  }

  const selectedDiningOption = selectedDiningOptionParam
    ? Object.values(DiningOptionBehavior).find(
        (opt) => opt.toString() === selectedDiningOptionParam
      )
    : undefined

  return (
    <>
      <Meta
        primaryColor={color ?? undefined}
        icon=''
        domain=''
        siteTheme={siteTheme}
      />
      <Map
        orderPathPattern={orderPathPattern}
        hostName={hostName}
        markerStyle={style}
        sourceId={sourceId}
        useOrderFulfillment={true}
        targetOrigin={targetOrigin}
        locationGuids={locationGuids}
        selectedGuid={selectedGuid}
        color={color ?? undefined}
        selectedDiningOption={selectedDiningOption}
      />
    </>
  )
}

export default withRouter<Props, React.ComponentType<Props>>(MapPage)
